import React from "react";
import "./Biometric.css";
import biohrm from "../Products/Products/bio-hrm-hero.jpg";
import Hrm from "../Products/Products/bio-hrm1.avif";
import bio_metric from "../Products/Products/bio-hrm2.jpg";
import { Helmet } from "react-helmet-async";
import Banner from "../../Banner/Banner";
// import "../../../index.css"

const BiometricPage = () => {
  return (
    <>
      <Helmet>
        <title>Biometric Attendance & Security Software</title>

        <meta
          name="description"
          content="Our biometric attendance and security software helps track staff attendance and control access using fingerprint and face ID for smarter business security."
        />
        <meta
          name="keywords"
          content="Workforce management, Security system, Time tracking, Attendance tracking, Biometric system, Staff attendance, Identity verification"
        />


        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://kitkatsoftwaretechnologies.com/biometric-attendance" />

        {/* <!-- Hreflang Tags --> */}
        <link rel="alternate" hrefLang="en-US" href="https://kitkatsoftwaretechnologies.com/biometric-attendance" />
        <link rel="alternate" hrefLang="en-GB" href="https://kitkatsoftwaretechnologies.com/biometric-attendance" />
        <link rel="alternate" hrefLang="en-MY" href="https://kitkatsoftwaretechnologies.com/biometric-attendance" />
        <link rel="alternate" hrefLang="en-SG" href="https://kitkatsoftwaretechnologies.com/biometric-attendance" />
        <link rel="alternate" hrefLang="en-AE" href="https://kitkatsoftwaretechnologies.com/biometric-attendance" />
        <link rel="alternate" hrefLang="x-default" href="https://kitkatsoftwaretechnologies.com/biometric-attendance" />

      </Helmet>
      <Banner image={biohrm} alt="Biometric" />


      <div className="content_lists">
        <div className="product_cont">
          <div className="career_p">
            <h1 className="product_title">Easy Biometric Attendance & Access Control Software</h1>
            <p className="cont_para_style">
              Biometric-based HRM software from KitKat Software Technologies simplifies and
              modernizes human resource management by securely tracking employee attendance
              through advanced identification methods such as fingerprint authentication. This
              intelligent system eliminates manual attendance registers, prevents buddy punching,
              and enhances workplace discipline, ensuring greater transparency and accuracy in HR
              operations.
            </p>
            <p className="cont_para_style">
              Our biometric HRM solution automates attendance tracking, leave management, shift
              scheduling, and payroll integration, significantly reducing administrative workload. By
              minimizing errors and manual intervention, HR managers can focus more on strategic
              tasks rather than routine processes. The system improves punctuality, boosts employee
              accountability, and contributes to a well-organized and secure work environment.
            </p>

            <div className="img_pro">
              <img
                src={Hrm}
                width="100%"
                height="100%"
                alt="Hrm Management"
                style={{ objectFit: "cover" }}
              />
            </div>

            {/* Frequently Asked Questions Section */}
            <div>
              <p className="cont_para_style">
                With real-time monitoring and centralized data management, HR teams can easily
                access attendance records, generate detailed reports, and analyze workforce
                performance from anywhere. The software provides valuable insights that support
                better decision-making and workforce planning. Our solution is scalable and designed to
                meet the needs of businesses of all sizes, from startups and small enterprises to large
                organizations.
              </p>
              <p className="cont_para_style">
                At KitKat Software Technologies, we offer fully customized biometric HRM solutions
                tailored to your specific operational requirements. Our goal is to deliver secure,
                user-friendly, and reliable systems that improve efficiency, enhance employee
                satisfaction, and support long-term business growth.
              </p>
            </div>
            <div className="img_pro">
              <img
                src={bio_metric}
                width="100%"
                height="100%"
                alt="Bio-metric"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BiometricPage;
